export default __webpack_public_path__ + "static/storycard_dark-bd80d1727928f781d2fcbfa7dc488fd0.png";